document.addEventListener('DOMContentLoaded', function () {
  var header = document.querySelector('.section-header');
  if (!header) {
    return;
  }

  function measure() {
    var height = header.getBoundingClientRect().height;
    if (height > 0) {
      document.documentElement.style.setProperty('--measured-header-height', height + 'px');
    }
  }

  measure();
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);
  setTimeout(measure, 300);
});
